import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { WorkspaceTaskGroupRow } from "../workspaceTaskGroupsViewConfig";
import styles from "../WorkspaceTaskGroups.module.scss";

export const TaskGroupNameCell = memo(
    ({
        row,
    }: CellContext<ViewTableFeatures, WorkspaceTaskGroupRow, string>) => (
        <span className={styles.name}>{row.original.name}</span>
    ),
);
